
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.098 42.82v1.431a2.27 2.27 0 01-1.926 2.249l-.353 1.3a1.619 1.619 0 01-1.563 1.2h-3.498a1.619 1.619 0 01-1.563-1.2l-.343-1.3a2.28 2.28 0 01-1.936-2.259V42.81c0-.767.615-1.382 1.381-1.382h8.42c.766.01 1.38.625 1.38 1.392zm6.483-19.298c0 3.257-1.291 6.21-3.388 8.378a11.07 11.07 0 00-2.964 6.01 1.996 1.996 0 01-1.976 1.683H19.76c-.978 0-1.825-.706-1.966-1.674-.353-2.248-1.391-4.385-2.984-6.029a12.02 12.02 0 01-3.368-8.237 12.036 12.036 0 0111.988-12.2c6.705-.05 12.15 5.374 12.15 12.069zm-10.708-7.31c0-.746-.605-1.36-1.361-1.36-4.8 0-8.711 3.901-8.711 8.71a1.362 1.362 0 002.722 0 5.996 5.996 0 015.989-5.989c.756 0 1.361-.605 1.361-1.36zm-1.361-8.72c.746 0 1.361-.606 1.361-1.362V1.361a1.362 1.362 0 00-2.722 0V6.13c0 .756.615 1.361 1.36 1.361zm-16.02 16.02c0-.746-.606-1.361-1.362-1.361H1.361a1.362 1.362 0 000 2.722H6.13c.756 0 1.361-.605 1.361-1.361zm38.17-1.361h-4.768a1.362 1.362 0 000 2.722h4.769a1.362 1.362 0 000-2.722zM10.265 34.844l-3.378 3.378a1.357 1.357 0 101.916 1.926l3.377-3.378a1.357 1.357 0 000-1.926 1.345 1.345 0 00-1.915 0zm25.538-22.261c.343 0 .696-.131.958-.393l3.378-3.378a1.357 1.357 0 000-1.926 1.357 1.357 0 00-1.926 0l-3.378 3.378a1.357 1.357 0 000 1.926c.273.262.615.393.968.393zm-25.538-.404a1.359 1.359 0 001.916 0 1.357 1.357 0 000-1.925L8.801 6.876a1.357 1.357 0 00-1.926 0 1.357 1.357 0 000 1.926l3.388 3.377zM36.76 34.844a1.357 1.357 0 00-1.926 0 1.357 1.357 0 000 1.926l3.378 3.378a1.36 1.36 0 001.916-1.926l-3.368-3.378z","fill":"#fff","fill-opacity":".65","opacity":".75"}})])
          )
        }
      }
    